// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"72":"8017dff9","114":"a97f4294","298":"827a5f3b","388":"aabfd5c6","497":"e73831dc","583":"1230b63d","612":"89ceb495","656":"c1dab289","703":"b49902a4","824":"81b0abd7","852":"ff683807"}[chunkId] + ".css";
};